import Box from "@mui/material/Box";
import { PropsWithChildren } from "react";

export default function BibleRef(props: PropsWithChildren<{
    ver?: string,
    parentheses?: boolean,
    style?: boolean,
    reference?: string,
    dash?: boolean
}>) {

    const { children, ver, parentheses, style, reference, dash } = props;

    function getReference() {
        return reference || children?.toString();
    }

    const link = (
        <>
            {dash && '— '}
            <a
                href={`https://www.biblegateway.com/passage/?search=${getReference() || ''}&version=${ver ? ver : 'RVR1960'}`}
                target="_blank"
                style={{
                    fontStyle: 'normal'
                }}
            >
                {children}
            </a>
        </>
    );

    return (
        <>
            {
                parentheses
                    ?
                    <Box component='span' sx={{
                        ...(style && {
                            pt: '3px',
                            pb: '2px',
                            px: '2px',
                            borderRadius: '3px',
                            backgroundColor: 'rgb(245, 245, 245)',
                            color: 'rgb(175, 175, 175)',
                            'a': {
                                color: 'inherit',
                                textDecorationColor: 'rgb(220, 220, 220)',
                            }
                        })
                    }}>
                        ({link})
                    </Box>
                    :
                    link
            }
        </>
    );
}

// import Box from "@mui/material/Box";
// import { PropsWithChildren } from "react";
// import Tooltip from '@mui/material/Tooltip'
// import FetchVerses from "./FetchVerses";

// export default function BibleRef(props: PropsWithChildren<{ver?: string, parentheses?: boolean, style?: boolean, reference?: string, dash?: boolean}>) {

//     const { children, ver, parentheses, style, reference } = props

//     function getReference() {
//         if (reference) {
//             return reference
//         } else {
//             return children?.toString()
//         }
//     }

//     return (
//         <>
//             {
//                 parentheses
//                     ? 
//                     <Box component='span' sx={{
//                         ...(
//                             style && {
//                                 pt: '3px',
//                                 pb: '2px',
//                                 px: '2px',
//                                 borderRadius: '3px',
//                                 backgroundColor: 'rgb(245, 245, 245)',
//                                 color: 'rgb(175, 175, 175)',
//                                 'a': {
//                                     color: 'inherit',
//                                     textDecorationColor: 'rgb(220, 220, 220)',
//                                 }
//                             }
//                         )
//                     }}>(<a
//                             href={`https://www.biblegateway.com/passage/?search=${getReference() || ''}&version=${ver ? ver : 'RVR1960'}`}
//                             target="_blank"
//                             style={{}}
//                         >
//                             { children }
//                         </a>)</Box>
//                     :
//                         <a
//                             href={`https://www.biblegateway.com/passage/?search=${getReference() || ''}&version=${ver ? ver : 'RVR1960'}`}
//                             target="_blank"
//                             style={{}}
//                         >
//                             {children}
//                         </a>
//             }
//         </>
//     )
// }